import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import { Device, until } from '@helpers/media';
import { ReactComponent as SvgNavSwap } from '@img/icons/repeat-swap.svg';
import styled from 'styled-components';
const Container = styled.nav `
  ${setCssVar('bgColor', brand.greyVeryLight)};

  .theme-apl & {
    ${setCssVar('bgColor', brand.greyVeryLight)};
  }

  .theme-hh & {
    ${setCssVar('bgColor', brand.hortHouse.greyMid)};
  }

  .theme-rss & {
    ${setCssVar('bgColor', brand.rss.grey)};
  }

  display: block;
  background-color: ${cssVar('bgColor')};
`;
const List = styled.ul `
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0 25px;

  @media ${until(Device.TabletLarge)} {
    display: none;
  }
`;
const SwapButton = styled.button `
  @media ${until(Device.TabletLarge)} {
    display: none;
  }

  cursor: pointer;
  border-radius: 0;
  background-color: ${brand.hta.green};
  border: 0;
  padding: 0;
  display: inline;
  position: absolute;
  z-index: 999999;
  bottom: 0px;
  height: 62px;
  width: 45px;

  span {
    font-size: 10px;
    font-weight: 700;
  }
`;
const SwapIcon = styled(SvgNavSwap) `
  height: 21px;
  width: 21px;
`;
export default {
    Container,
    List,
    SwapButton,
    SwapIcon,
};
